/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Ricarica { 
    id_studente: string;
    numero_bollettino?: string;
    valore: number;
    data_pagamento?: string;
    note?: string;
}

